import gameConfig from '../../assets/config';

import UbuntuBold from '../../assets/fonts/ubuntu/UBUNTU-B.TTF';
import UbuntuRegular from '../../assets/fonts/ubuntu/UBUNTU-R.TTF';
import MyriadPro from '../../assets/fonts/ubuntu/MYRIADPRO-BOLD.OTF';
import { soundsPreloaderConfig } from '../enums/eSounds';
import eAnimationTypes from '../enums/eAnimationTypes';
import starParticle from '../../assets/images/starParticle.png';

import flashlib from '../../assets/exported/game/FlashLib.json';
// import assets from '../../assets/exported/game/FlashLibAssets';

const assets = 'flashlib/game/AssetsCombined.json';
export default {
  assets: [
    { name: 'GameAssets', path: assets, extension: 'json' },
    { name: 'GameFlashLib', path: flashlib, extension: 'json' },
    { name: 'gameConfig', path: gameConfig, extension: 'json' },
    { name: eAnimationTypes.SYMBOLS, path: 'animations/symbols/symbols_Chervona_Kalyna_pro.json' },
    { name: 'BMFont', path: 'fonts/BMFont/BMFont.xml' },
    { name: 'starParticle', path: starParticle },
  ],
  delayedAssets: [
    { name: eAnimationTypes.BIG_WIN, path: 'animations/bigWins/dwb_CK.json' },
    { name: eAnimationTypes.COIN, path: 'animations/coin/coin.json' },
  ],
  fonts: [
    {
      name: 'UbuntuBold',
      path: UbuntuBold,
    },
    {
      name: 'Myriad Pro',
      path: MyriadPro,
    },
  ],
  sounds: soundsPreloaderConfig
}
